export const PAYMENT_CONFIG_REQUEST_TIMEOUT_MS = 15000

export function isAbortError(error) {
  return (
    error?.name === 'AbortError' ||
    error?.code === 'ERR_CANCELED' ||
    error?.message === 'canceled'
  )
}

export function createMountedGuard() {
  let isMounted = true

  return {
    isMounted: () => isMounted,
    cleanup: () => {
      isMounted = false
    },
  }
}

export function createAbortableRequest() {
  const abortController = new AbortController()
  const mountedGuard = createMountedGuard()

  return {
    requestConfig: {
      timeout: PAYMENT_CONFIG_REQUEST_TIMEOUT_MS,
      signal: abortController.signal,
    },
    isMounted: mountedGuard.isMounted,
    abort: () => {
      mountedGuard.cleanup()
      abortController.abort()
    },
  }
}
